<template>
    <b-container class="mt20">
        <b-breadcrumb :items="bread"></b-breadcrumb>
        <div class="detail-title" style="text-align: center;">{{ news.title }}</div>
        <div class="detail-time mt10" style="text-align: center;">发布日期：{{ news.createTime }}</div>

        <div class="detail-title-line"></div>

        <div v-html="news.content" style="min-height:300px; text-align: justify;"></div>

        <link-component></link-component>
    </b-container>
</template>

<script>
import LinkComponent from '@/components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';

export default {
    components: { LinkComponent },
    name: 'NewsDetail',
    props: {},
    data() {
        return {
            bread: [
                {
                    text: '首页',
                    to: '/index'
                },
                {
                    text: '新闻',
                    to: '/news'
                }
            ],
            news: {}
        };
    },

    created() {
        this.requestNotice();
    },

    mounted() { },

    methods: {
        //请求公告
        requestNotice() {
            axiosServer({
                url: urls.svpNews + '/' + this.$route.query.id
            }).then(resp => {
                this.news = resp.data.entity;
                this.bread.push(this.news.title);
            });
        }
    }
};
</script>

<style scoped>
.detail-title {
    font-size: 25px;
    font-weight: bold;
}

.detail-time {}

.detail-title-line {
    height: 1px;
    background-color: #d6d5d5;
    margin-top: 20px;
    margin-bottom: 20px;
}
</style>
